<main>
  <section class="layout-pt-lg layout-pb-lg">
    <div class="container">
      <div class="row y-gap-30 justify-center items-center">
        <div class="col-lg-6 text-center">
          <img src="assets/img/general/404.svg" alt="404 - Sayfa Bulunamadı" class="mb-30">
        </div>

        <div class="col-lg-5">
          <div class="no-page">
            <div class="no-page__title">40<span class="text-blue-1">4</span></div>

            <h2 class="text-30 fw-600">Aradığınız sayfa bulunamadı.</h2>

            <div class="pr-30 mt-5 text-light-1">Aradığınız sayfa mevcut değil veya taşınmış olabilir. Ana sayfaya dönebilirsiniz.</div>

            <div class="d-inline-block mt-40 md:mt-20">
              <a routerLink="/" class="button -md -dark-1 bg-blue-1 text-white">Ana Sayfaya Dön</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="layout-pt-md layout-pb-md bg-dark-2">
    <div class="container">
      <div class="row y-gap-30 justify-between items-center">
        <div class="col-auto">
          <div class="row y-gap-20 flex-wrap items-center">
            <div class="col-auto">
              <div class="icon-newsletter text-60 sm:text-40 text-white"></div>
            </div>

            <div class="col-auto">
              <h4 class="text-26 text-white fw-600">Seyahat Yolculuğunuz Burada Başlıyor</h4>
              <div class="text-white">Kayıt olun, en iyi fırsatları size gönderelim</div>
            </div>
          </div>
        </div>

        <div class="col-auto">
          <div class="single-field -w-410 d-flex x-gap-10 y-gap-20">
            <div>
              <input class="bg-white h-60" type="email" placeholder="E-posta adresiniz">
            </div>

            <div>
              <button class="button -md h-60 bg-blue-1 text-white">Abone Ol</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
